// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3csPL","header":"ReportDetails_header__2PfS6","title":"ReportDetails_title__2P8VG","left":"ReportDetails_left__1Mexf"};